<template>
  <div id="editAbsenteeism" class="d-flex">
    <MainBarMenuV2 />
    <b-container class="container-fluid">
        <b-row>
            HOLA
        </b-row>
    </b-container>
   </div>
</template>

<script>
//import { mapState,mapActions } from "vuex";
import MainBarMenuV2 from "../../components/layouts/MainBarMenuV2.vue";
import HeadingUser from "../../components/user/HeadingUser.vue";

export default {
    name: "editAbsenteeism",
    components: {
        MainBarMenuV2,
        HeadingUser,
        // Absenteeism: () => import('../../components/healthTracker/editAbsenteeism.vue'),
        // WorkerInfoV2: () => import('../../components/healthTracker/workerInfo/WorkerInfoV2.vue'),
    },
  data() {
      return {
        carlos: "hola",
      }
  },
  computed: {
  },
  beforeMount() {
 console.log("hola carga")
    },
  methods: {
    }
}
</script>

<style lang="scss">
</style>
